import { BookMultipleIcon } from './BookMultipleIcon';

/**
 * author: Austin Andrews
 * id 637C4988-5432-4F5E-ADD5-EBDC397D0622
 * name book-multiple
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-multiple.svg
 * tags
 */
export const BooksIcon = BookMultipleIcon;
export default BooksIcon